import TuitionHistory from "@/components/TuitionHistory";

export function StudentBillingCard({ studentId }) {
  return <TuitionHistory endpoint={`/billing/invoices?student_id=${encodeURIComponent(studentId)}`} compact />;
}
